import React, { createContext, useContext, useState } from 'react'

interface ComissionsReportContextData {
  setFilters: React.Dispatch<React.SetStateAction<any>>
  filters: any
}

export const ComissionsReportContext =
  createContext<ComissionsReportContextData>({} as ComissionsReportContextData)

export const ComissionsReportProvider: React.FC = ({ children }) => {
  const [filters, setFilters] = useState<any>({})

  return (
    <ComissionsReportContext.Provider
      value={{
        setFilters,
        filters
      }}
    >
      {children}
    </ComissionsReportContext.Provider>
  )
}

export function useComissionsReportContext() {
  return useContext(ComissionsReportContext)
}
